// extracted by mini-css-extract-plugin
export default {"card":"Card_card__-SwHU","card-content":"Card_card-content__qTtUg","card-title":"Card_card-title__bMsyM","card-subtitle":"Card_card-subtitle__l79DZ"};